import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CloudPayConfiguration} from './types/cloud-pay-configuration.type';
import {CONFIG_TOKEN} from './cloud-pay-tokens';
import {ScriptTagModule} from '@streamamg/amg-common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ScriptTagModule
  ]
})
export class CloudPayModule {
  static forRoot(config: CloudPayConfiguration): ModuleWithProviders<CloudPayModule> {
    return {
      ngModule: CloudPayModule,
      providers: [
        {
          provide: CONFIG_TOKEN,
          useValue: config
        }
      ]
    };
  }
}
